import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/my-initiatives.action';
import { switchMap, map, catchError, tap, withLatestFrom } from 'rxjs/operators';
import { InitiativesService } from '../../services';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Router } from '@angular/router';
import { Go } from '../../../store';
import { Store } from '@ngrx/store';
import { getInitiativesPage, getInitiativesSortOrder } from '../selectors';
import { getGeoLocationPosition } from 'src/app/geo-location/store';

@Injectable()
export class MyInitiativesEffects {
  constructor(
    private actions$: Actions,
    private service: InitiativesService,
    private router: Router,
    private sb: MatSnackBar,
    private store: Store
  ) {}

  LoadMyInitiatives$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actions.LoadMyInitiatives),
      switchMap(() =>
        this.service.getMyInitiatives().pipe(
          map(initiatives => actions.LoadMyInitiativesSuccess({ initiatives })),
          catchError(error => of(actions.LoadMyInitiativesFail({ error })))
        )
      )
    );
  });
}
